import { productFruits } from 'product-fruits';

// later in the code

export default defineNuxtPlugin((app) => {
    const { public: runtimeConfig } = useRuntimeConfig();

    if (!runtimeConfig.productFruits.workspaceCode) {
        return;
    }

    const { user, loggedIn } = useUserSession();

    if (!loggedIn.value) {
        return;
    }

    // @ts-expect-error - locale is not defined in the type
    const locale = user.value.locale?.split('-')[0] ?? 'en';
    // @ts-expect-error - locale is not defined in the type
    const username = user.value.uuid;

    productFruits.init(
        runtimeConfig.productFruits.workspaceCode,
        locale,
        {
            username,
        },
        {
            disableLocationChangeDetection: true,
        },
    );

    app.hook('page:finish', (_context) => {
        if (!loggedIn.value) {
            return;
        }

        // @ts-expect-error - $productFruits is not a defined global object
        $productFruits.push(['pageChanged']);
    });
});
